import React, { FC, useState } from 'react';
import { Dayjs } from 'dayjs';

import { Box, TextField, Popover } from '@mui/material';
import { Calendar } from 'react-feather';
import { Selector } from './Selector';
import { PVBlack } from '@pv/common/colors';

import type { VoidFn, Nullable } from '../../../types/common';
import { EventDatePicker } from '../pickers/EventDatePicker';
import type {
  PartialExpressBookSettings,
  HoursOfOperation,
} from '../../../types/models/venue_types';

/*
 * Types.
 */

export interface EventDateSelectorProps {
  eventDate: Nullable<Dayjs>;
  onChangeEventDate: VoidFn<Nullable<Dayjs>>;
  expressBookSettings?: PartialExpressBookSettings;
  hoursOfOperation?: HoursOfOperation;
}

export const EventDateSelector: FC<EventDateSelectorProps> = ({
  eventDate,
  onChangeEventDate,
  expressBookSettings,
  hoursOfOperation,
}: EventDateSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Selector>
      <Calendar
        color={PVBlack}
        style={{
          marginBottom: '16px',
        }}
      />
      <TextField
        size="small"
        label="Date"
        value={eventDate?.format('MMM DD, YYYY') ?? 'Any date'}
        InputProps={{
          readOnly: true,
        }}
        onClick={handleClick}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            handleClick(event);
          }
        }}
      />

      <Popover
        id="event-date-selector-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box padding="24px">
          <EventDatePicker
            eventDate={eventDate}
            onChangeEventDate={onChangeEventDate}
            onClose={handleClose}
            shouldRenderActionBar
            shouldCloseOnChange
            expressBookSettings={expressBookSettings}
            hoursOfOperation={hoursOfOperation}
          />
        </Box>
      </Popover>
    </Selector>
  );
};
